var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.432 7.5C20.432 5.70508 18.9769 4.25 17.182 4.25H6.68201C4.88708 4.25 3.43201 5.70507 3.43201 7.5V16.5C3.43201 18.2949 4.88708 19.75 6.68201 19.75H17.182C18.9769 19.75 20.432 18.2949 20.432 16.5V7.5ZM21.932 16.5C21.932 19.1234 19.8054 21.25 17.182 21.25H6.68201C4.05865 21.25 1.93201 19.1234 1.93201 16.5V7.5C1.93201 4.87665 4.05865 2.75 6.68201 2.75H17.182C19.8054 2.75 21.932 4.87665 21.932 7.5V16.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7622 6.93867C21.1217 6.73346 21.5792 6.85858 21.7847 7.21797C21.9902 7.57758 21.866 8.03585 21.5064 8.24141L14.2808 12.3713L14.2798 12.3703C13.5629 12.7852 12.7498 13.0051 11.9214 13.0051C11.0912 13.0051 10.2752 12.7851 9.55713 12.3684V12.3674L2.35596 8.24043C1.99674 8.03439 1.87266 7.5763 2.07862 7.21699C2.28466 6.85777 2.74275 6.73369 3.10206 6.93965L10.3071 11.0695L10.3101 11.0715C10.7995 11.3555 11.3556 11.5051 11.9214 11.5051C12.4872 11.5051 13.0433 11.3555 13.5327 11.0715L13.5366 11.0686L20.7622 6.93867Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2d1b07fddf756efce7fb4918c2f81a73.svg";
export { ForwardRef as ReactComponent };